<template lang="pug">
.w-100
    .tabela(v-if='false')
        
    EmptyResultLaudo(
         v-else
        :semLaudoSelecionado='true'
        :p1="$t('mensagens.laudos.nenhumLaudoSelecionado')",
        :p2="$t('mensagens.laudos.selecioneTipoDeLaudoParaVisualisar')"
    )
</template>

<script>
import EmptyResultLaudo from '@/components/laudos/EmptyResultLaudo.vue';

export default {
    name: 'LaudoListagemAnalistaDashboard',
    emits: ['handleModalInsercaoResultados'],
    components: {
        EmptyResultLaudo
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.el-table {
    .cell {
        word-break: break-word !important;
    }

    .action-button {
        cursor: pointer;
    }
}

.indicador {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    display: inline-block;
    margin: 0 auto;
    max-width: 150px;
}

.em-processamento {
    background-color: var(--warning);
}

.processado {
    background-color: #191a4b;
}

.conforme {
    background-color: #d5f8d7;
    border: 1px solid #b0dcb3;
}

.nao-conforme {
    background-color: #f7d6da;
    border: 1px solid #e58585;
}

.situacao {
    border-radius: 50px;
    text-align: center;
    color: var(--white);
}

.status {
    border-radius: 50px;
    text-align: center;
    color: var(--black);
}

.conforme {
    background-color: var(--background-according);
    border: 1px solid var(--success);
}

.nao-conforme {
    background-color: var(--nonconforming-report);
    border: 1px solid var(--danger);
}

.buttonCard {
    background: var(--white);
    height: 60px;
    top: -15px;
    position: relative;
    padding: 10px;
    display: flex;
    align-items: center;
}
</style>
